export default "__VITE_ASSET__igCcUtQG__"